// Interview User Info *************************************************************************
// pathname: /v1/interview/user-info
// ************************************************************************************************
import { ApiInterviewUserInfoOk, useSwrApi } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch interview user info
 * @param locale
 */
export const useSwrInterviewUserInfo = (locale: string) => {
  // SWR: fetch data
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiInterviewUserInfoOk>({
    url: '/v1/interview/user-info',
    locale,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60000, // 1 minute
    },
  });

  // Return data
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
